// Signed in, but this page is not for you (issue #755).
//
// Every guard used to answer this case with <Navigate to="/" replace />: the URL
// silently became the home page. A customer following a link they were sent had
// no way to tell whether the page was gone, broken, or simply not theirs — and
// no idea what to do about it. Being turned away is fine; being turned away
// without being told is not.
//
// It deliberately does not say which roles would grant access. The visitor may be
// a customer we do not know, and the shape of our internal roles is not theirs to
// learn.

import React from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../theme';

export default function NoAccessNotice({ pageName }) {
  return (
    <div className="ni-page">
      <div className="ni-shell ni-shell--narrow">
        <div
          className="ni-panel"
          style={{
            maxWidth: 460, margin: '3rem auto', padding: '1.75rem 1.5rem',
            display: 'flex', flexDirection: 'column', gap: '0.9rem', textAlign: 'center',
          }}
        >
          <img src="/north-invent-logo.svg" alt="North Invent" style={{ height: 22, opacity: 0.9, margin: '0 auto' }} />

          <div>
            <h1 style={{ margin: '0 0 0.35rem', fontSize: '1.15rem', color: colors.textStrong }}>
              You don&rsquo;t have access to this page
            </h1>
            <p style={{ margin: 0, color: colors.textMuted, lineHeight: 1.55, fontSize: '0.9rem' }}>
              {pageName
                ? <>Your account is signed in, but it isn&rsquo;t set up for <strong style={{ color: colors.textBody }}>{pageName}</strong>.</>
                : <>Your account is signed in, but it isn&rsquo;t set up for this page.</>}
              {' '}If you think it should be, ask your North Invent contact to update it.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '0.6rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="ni-button ni-button--primary" style={{ textDecoration: 'none' }}>
              Go to device lookup
            </Link>
            <Link to="/helpdesk" className="ni-button ni-button--ghost" style={{ textDecoration: 'none' }}>
              Helpdesk
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
